<template>
  <div class="baidumap-component" :style="styleObject">
    <div id="baiduMap" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import plugins from "./plugin"

export default {
  mixins: [eventMixin, plugins, subPageEventMixin],
  name: "cxBaidumap",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  components: {},
  watch: {
    "options.content": function (newVal) {
      this.initMap()
    }
  },
  data() {
    return {
      centerPoint: {
        lng: 116.404,
        lat: 39.915
      },
      zoom: 3,
      address: '',
      map: null
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    styleObject() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let thisStyle = {
        color: this.$parseColor(this.options.color),
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor,{isThemeColor:this.options.borderIsThemeColor}),
        "border-width": borderW,
        "box-shadow": this.boxShadowStyle,
        // "background-image": "url(" + this.options.imgSrc + ")",
        // "background-repeat": this.options.repeatType,
        // "background-size": this.options.clipSize,
        // "background-position": this.options.alignType,
        opacity: this.options.opacity,
        padding: this.getPaddingStyle,
        width: "100%",
        height: "100%",
      }
      return {
        ...this.bgStyle,
        ...thisStyle
      }
    },
    styleObject1(){
      return {
        width: "100%",
        height: "100%",
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.paddingTypeFlag || this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
  },
  mounted() {
    this.loadBaiduMapAPI();
  },
  methods: {
    loadBaiduMapAPI() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `http://api.map.baidu.com/api?v=3.0&ak=AI3G0oPB8cwzT5OOpGGb3Z9cB44i6jdw&callback=initMap`;
      document.head.appendChild(script);
      window.initMap = () => {
        this.map = new BMap.Map("baiduMap"); // 初始化地图，创建实例
        this.initMap()
      }
    },
    initMap() {
      const geocoder = new BMap.Geocoder();
      geocoder.getPoint(this.options.content, (point) => {
        if (point) {
          this.map.centerAndZoom(point, 15);
        } else {
          alert("地址未找到");
        }
      }, "您的城市"); // 将 "您的城市" 替换为预期的地址所在城市，或者留空进行更广泛的搜索
    },
    async updateData() {
      // if (this.options.restDataUrl) {
      //   this.getBaseModuleDataLoop()
      // }
    }
  },
  beforDeDestroy() {
    this.map.destroy();
    document.head.removeChild(document.querySelector('script[src="http://api.map.baidu.com/api?v=3.0&ak=AI3G0oPB8cwzT5OOpGGb3Z9cB44i6jdw"]'));
  },
}
</script>

<style scoped>

</style>